import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import useCommonStore from 'store/common';
import ImageCropper from './ImageCropper';

const SignUpProfileCropper: React.FC<any> = () => {
	const { modalConfig = {} }: any = useCommonStore((state) => state);
	const { updateImageData = () => {}, defaultImage = '' } = modalConfig?.data ?? {};

	return (
		<Modal.Body>
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={() => modalConfig?.onClose()}
			>
				<i className="ri-close-line"></i>
			</Button>
			<Form className="edit-form">
				<ImageCropper
					updateImageData={updateImageData}
					imgRation={1 / 1}
					defaultImage={defaultImage}
				/>
			</Form>
		</Modal.Body>
	);
};

export default SignUpProfileCropper;
